
import { getProject } from '@/utils/api'
import { PROJECT_CODE } from '@/utils/constants'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import IconArrowBack from '../svg/IconArrowBack.vue'

@Options({
  components: {
    IconArrowBack,
  },
  name: 'NotFound',
})
export default class NotFound extends Vue {
  @Prop({ type: String }) readonly item: string = 'item'
  customURL = ''

  async created() {
    if (!this.$store.state.project.details) {
      const { project } = await getProject(PROJECT_CODE)
      this.customURL = project?.customLogoImageUrl
    }
  }

  get image() {
    return this.customURL || require('@/assets/logo-smartBarcode.png')
  }

  get isLoading() {
    return this.$store.getters.isLoading
  }
}
